import { Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import logo from "../assets/Logo-white.png";
import plus from "../assets/18plus.png"

export default function Footer(){
    return(
     <footer>
    <Container>
        <Row>
            <Col className="text-center py-5">
            {/* <Link to="/"><img src={logo} alt="Logo" /></Link> */}
            </Col>
        </Row>
    </Container>

    {/* New Contact Information Section */}
    <Container className="contact-info-section py-5">
        <Row>
            <Col md={4} className="contact-item">
                <div className="contact-icon">
                    <i className="fas fa-phone" style={{ color: '#B4975A' }}></i>
                </div>
                <div className="contact-content">
                    <h4 className="contact-title">Phone</h4>
                    <p className="contact-text">+47 22 83 70 10</p>
                </div>
            </Col>
            <Col md={4} className="contact-item">
                <div className="contact-icon">
                    <i className="fas fa-envelope" style={{ color: '#B4975A' }}></i>
                </div>
                <div className="contact-content">
                    <h4 className="contact-title">Email</h4>
                    <p className="contact-text">Trundibloop@gmail.com</p>
                </div>
            </Col>
            <Col md={4} className="contact-item">
                <div className="contact-icon">
                    <i className="fas fa-map-marker-alt" style={{ color: '#B4975A' }}></i>
                </div>
                <div className="contact-content">
                    <h4 className="contact-title">Address</h4>
                    <p className="contact-text">Dronning Eufemiasgate 16,<br /> 0191 Oslo, Norway</p>
                </div>
            </Col>
        </Row>
    </Container>

    <Container className="footerTop py-4">
        <Row>
            <Col xs={12} md={6} className="mb-3 mb-md-0">
                <h3 className="h3Heading text-yellow">Ensuring everyone plays responsibly</h3>
                <p className="footerSub">Learn more on our dedicated page for Responsible Social Gaming.</p>
            </Col>
            <Col xs={10} md={5} className="mb-3 mb-md-0">
                <p className="highlight mobile-full-width">
                    <Link to="/responsible-social-gaming">GO TO RESPONSIBLE SOCIAL GAMING</Link>
                </p>
            </Col>
            <Col xs={2} md={1} className="text-right">
                <img src={plus} alt="18+" className="age-restriction" />
            </Col>
        </Row>
    </Container>
    
    <Container className="footerMiddle pb-4">
        <Row>
            <Col xs={12} md={9} className="mb-4 mb-md-0">
                <div className="disclaimer-text">
                    <p>This is a free social casino focused on entertainment.</p>
                    <p>No real money is involved, and it is not possible to win cash prizes.</p>
                    
                    <p className="disclaimer-heading">Disclaimer:</p>
                    <p>This website is developed solely for free entertainment purposes.</p>
                    <p>All games on the site are self-developed and made for entertainment only.</p>
                    <p>The games are intended for adults over 18 years of age.</p>
                    <p>Our social casino games do not involve the use of real money and offer no possibility of winning prizes or cash rewards.</p>
                    <p>Progress in the games is not an indicator of skills in real money gambling.</p>
                    
                    <p className="disclaimer-footer">We encourage responsible play and emphasize that the games on Trundibloop are meant exclusively for entertainment.</p>
                </div>
            </Col>
            
            <Col xs={12} md={3} className="footer-links-col">
                <ul className="footer-links">
                    <Link to="/terms-of-service"><li>Terms of Service</li></Link>
                    <Link to="/responsible-social-gaming"><li>Responsible Social Gaming</li></Link>
                    <Link to="/privacy-policy"><li>Privacy Policy</li></Link>
                    <Link to="/contact-us"><li>Contact Us</li></Link>
                    <Link to="/disclaimer"><li>Disclaimer</li></Link>
                    <Link to="/about-us"><li>About Us</li></Link>
                </ul>
            </Col>
        </Row>
    </Container>
    
    <Container className="footerBottom py-3">
        <Row>
            <Col className="text-center">
                <p className="copyright">© 2025 Trundibloop AS – For entertainment only. No gambling. No real money. No cash prizes.</p>
            </Col>
        </Row>
    </Container>
</footer>

    )
}